// biome-ignore lint/correctness/noUnusedImports: existing error
import React, {useEffect} from 'react';

export const SEODescriptionBlock = () => {
  const desc = window.seo_description;
  useEffect(() => {
    /*
      The description html is defined in the CMS and uses classes to hide some SEO relevant content behind a click
      so the page doesn't get too long.
     */
    const readMoreLink = document.getElementById('gallery-seo-readmore');
    const hiddenContent = document.getElementById('gallery-seo-extra');

    const showHidden = () => {
      hiddenContent.classList.remove('collapse');
      hiddenContent.classList.add('uncollapse');
    };

    if (readMoreLink && hiddenContent) readMoreLink.addEventListener('click', showHidden);
  }, []);
  // biome-ignore lint/security/noDangerouslySetInnerHtml: existing error
  // biome-ignore lint/style/useNamingConvention: existing error
  return <div className="gallery__seo-desc" dangerouslySetInnerHTML={{__html: desc}} />;
};
